import React from 'react'
import { inject, observer } from 'mobx-react'
import SharedTargetGroupListContents from './SharedTargetGroupListContents'

const SharedTargetGroupList = ({ uiStore }) => (
  <dd className={uiStore.sharedTargetGroupsExpanded ? 'expanded' : ''}>
    {
      uiStore.sharedTargetGroupsExpanded
        ? <SharedTargetGroupListContents />
        : null
    }
  </dd>
)

export default inject('uiStore')(observer(SharedTargetGroupList))
